import Card from './Card.vue';
import { NAME } from './constants';

export const Vydejky = {
	name: NAME,
	components: {
		Card,
	},
};
